import { BrowserRouter, Route, Routes } from "react-router";
import Import from "./pages/Import";
import Home from "./pages/Home";
import CheckList from "./pages/CheckList";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Home />} />
        <Route path="import" element={<Import />} />
        <Route path="list" element={<CheckList />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;